export default "__VITE_ASSET__vT0gwHJm__"